import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import AnimatedSection from '../components/common/AnimatedSection';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Shield, Building2 } from 'lucide-react';

const VisionPage = () => {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const content = t('visionPage');

  const sectionIcons = [Target, Shield, Building2];

  return (
    <div className="pt-24">
      {/* Hero */}
      <section className={`section ${isDark ? 'bg-gradient-to-b from-[#1C1917] to-[#0C0A09]' : 'bg-gradient-to-b from-[#F5F0E8] to-[#FAFAF9]'}`}>
        <div className="container mx-auto px-4 lg:px-10">
          <div className="max-w-4xl mx-auto text-center">
            <AnimatedSection>
              <span className="caption mb-4 block">Vision</span>
              <div className="divider mx-auto mb-8" />
            </AnimatedSection>
            <AnimatedSection delay={0.1}>
              <h1 className="heading-display mb-8">
                {content.title}
              </h1>
            </AnimatedSection>
            <AnimatedSection delay={0.2}>
              <p className="body-large max-w-2xl mx-auto">
                Un nouveau modèle de gouvernance pour la Côte d'Ivoire.
              </p>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Vision Sections */}
      {content.sections.map((section, index) => {
        const Icon = sectionIcons[index];
        return (
          <section 
            key={index} 
            className={`section ${index % 2 === 0 
              ? isDark ? 'bg-[#0C0A09]' : 'bg-[#FAFAF9]' 
              : isDark ? 'bg-[#1C1917]' : 'bg-[#F5F0E8]'
            }`}
          >
            <div className="container mx-auto px-4 lg:px-10">
              <div className="max-w-5xl mx-auto">
                <div className="grid lg:grid-cols-5 gap-12 items-start">
                  {/* Icon Column */}
                  <AnimatedSection className="lg:col-span-2">
                    <div className="lg:sticky lg:top-32">
                      <div className={`w-20 h-20 rounded-2xl flex items-center justify-center mb-6 ${isDark ? 'bg-[#5B2D8E]/20' : 'bg-[#5B2D8E]/5'}`}>
                        <Icon className={`w-10 h-10 ${isDark ? 'text-[#7C4DAF]' : 'text-[#5B2D8E]'}`} />
                      </div>
                      <h2 className="heading-2 mb-4">{section.title}</h2>
                      <div className="divider" />
                    </div>
                  </AnimatedSection>

                  {/* Content Column */}
                  <div className="lg:col-span-3 space-y-6">
                    {section.paragraphs.map((paragraph, pIndex) => (
                      <AnimatedSection key={pIndex} delay={pIndex * 0.1}>
                        <p className="text-lg text-theme-secondary leading-relaxed" style={{ fontFamily: 'var(--font-serif)' }}>
                          {paragraph}
                        </p>
                      </AnimatedSection>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        );
      })}

      {/* CTA */}
      <section className="section bg-[#5B2D8E]">
        <div className="container mx-auto px-4 lg:px-10">
          <div className="max-w-3xl mx-auto text-center">
            <AnimatedSection>
              <h2 className="heading-1 text-white mb-6">
                Explorer les territoires
              </h2>
            </AnimatedSection>
            <AnimatedSection delay={0.1}>
              <p className="text-xl text-white/80 mb-10" style={{ fontFamily: 'var(--font-serif)' }}>
                Découvrez comment la décentralisation économique transformera chaque région.
              </p>
            </AnimatedSection>
            <AnimatedSection delay={0.2}>
              <Link 
                to="/territoires" 
                className="btn-secondary"
              >
                Voir les territoires
                <ArrowRight className="w-5 h-5" />
              </Link>
            </AnimatedSection>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VisionPage;
